import {useMutation} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    CreateMeeting as CreateMeetingMutation,
    CreateMeetingVariables as CreateMeetingMutationVariables,
    MeetingCreateInput,
} from 'nutshell-graphql-types';

import CREATE_MEETING from '../mutations/create-meeting.graphql';

export function useCreateMeeting(): {
    createMeeting: (arg1: MeetingCreateInput) => Promise<any>;
    isLoading: boolean;
    error: string | null | undefined;
} {
    const [createMeeting, {loading, error}] = useMutation<
        CreateMeetingMutation,
        CreateMeetingMutationVariables
    >(CREATE_MEETING);

    return {
        createMeeting: (input: MeetingCreateInput) =>
            createMeeting({
                variables: {input},
            }).then(
                (result) =>
                    result &&
                    result.data &&
                    result.data.meetingCreate &&
                    result.data.meetingCreate.meeting &&
                    result.data.meetingCreate.meeting.htmlUrlPath
            ),
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
    };
}
